import React from "react";
import { Drawer, Box } from "@mui/material";
import { X } from "lucide-react";
import "./AddNewDrawer.css";

function AddNewDrawer({
  open,
  onClose,
  title,
  subtext,
  icon,
  children,
  extraInfo,
  width = 400,
}) {
  const renderIcon = () => {
    if (!icon) return null;

    if (typeof icon === "string") {
      return (
        <div className="add-new-drawer-icon">
          <img src={icon} alt={title || "icon"} />
        </div>
      );
    }

    return <div className="add-new-drawer-icon">{icon}</div>;
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: width,
          overflow: "hidden",
          zIndex: 10020,
          display: "flex",
          flexDirection: "column",
        },
      }}
      ModalProps={{
        sx: { zIndex: 10020 },
      }}
    >
      {/* Header */}
      <Box className="add-new-drawer-header">
        <Box className="add-new-drawer-header-left">
          {renderIcon()}
          <Box>
            <h2 className="modalheading">{title}</h2>
            {subtext && <p className="modaldescription">{subtext}</p>}
          </Box>
        </Box>
        <button onClick={onClose} className="add-new-drawer-close-btn">
          <X size={18} />
        </button>
      </Box>

      {/* Content */}
       <Box className="add-new-drawer-content">
        {extraInfo && (
          <div className="drawer-extra-info">{extraInfo}</div>
        )}
        {children}
      </Box>
    </Drawer>
  );
}

export default AddNewDrawer;
